<div class="grid p-mobile-friendly animate-fade-in">
  <div class="col-12 md:col-8 md:col-offset-2 lg:col-6 lg:col-offset-3">
    <h1 class="text-center text-2xl md:text-3xl font-bold animate-slide-up">Select Agenda</h1>
    <p class="text-center text-color-secondary mb-4">Choose an agenda or skip to event</p>
  </div>

  <div class="col-12 md:col-8 md:col-offset-2 lg:col-6 lg:col-offset-3 mb-3">
    <a
      (click)="onSelectEvent()"
      (keyup.enter)="onSelectEvent()"
      (keyup.space)="onSelectEvent()"
      tabindex="0"
      class="block no-underline cursor-pointer"
    >
      <div class="card-modern shadow-hover p-4" style="background-color: rgba(255, 255, 255, 0.98)">
        <div class="flex align-items-center justify-content-start">
          <div class="flex align-items-center gap-3">
            <div
              class="w-3rem h-3rem border-circle flex align-items-center justify-content-center shadow-soft flex-shrink-0"
              style="background-color: var(--primary-color)"
            >
              <i class="pi pi-forward text-white text-xl"></i>
            </div>
            <div class="text-center">
              <h3 class="m-0 text-lg md:text-xl font-bold">Skip to Event</h3>
            </div>
          </div>
        </div>
      </div>
    </a>
  </div>

  @if (roomMenuList.length > 1) {
    <div class="col-12 md:col-8 md:col-offset-2 lg:col-6 lg:col-offset-3 mb-4">
      <div class="card-modern p-4" style="background-color: rgba(255, 255, 255, 0.98)">
        <label for="roomFilter" class="block text-sm font-semibold mb-3 text-color">Filter by Room</label>
        <p-dropdown
          #roomFilterDropdown
          [(ngModel)]="roomFilter"
          [options]="roomMenuList"
          id="roomFilter"
          name="roomFilter"
          optionLabel="label"
          optionValue="value"
          styleClass="w-full"
          [appendTo]="'body'"
          [showClear]="true"
          [filter]="false"
          placeholder="All rooms"
        />
      </div>
    </div>
  }

  <div class="col-12 md:col-8 md:col-offset-2 lg:col-6 lg:col-offset-3">
    <div class="grid gap-3">
      @for (agendaMenuItem of agendaMenuItemList; track agendaMenuItem; let i = $index) {
        @if (agendaMenuItem.room === roomFilter || roomFilter === null || roomFilter === '') {
          <div class="col-12 animate-slide-up" [style.animation-delay]="i * 0.1 + 's'">
            <a
              (click)="onSelectAgenda(agendaMenuItem.id)"
              (keyup.enter)="onSelectAgenda(agendaMenuItem.id)"
              (keyup.space)="onSelectAgenda(agendaMenuItem.id)"
              tabindex="0"
              class="block no-underline cursor-pointer"
            >
              <div class="card-modern shadow-hover p-4">
                <div class="flex align-items-center">
                  <!-- Icon on the left -->
                  <div
                    class="w-3rem h-3rem border-circle flex align-items-center justify-content-center shadow-soft flex-shrink-0"
                    style="background-color: var(--primary-color)"
                  >
                    <i class="pi pi-calendar-times text-white text-xl"></i>
                  </div>

                  <!-- Text content vertically aligned to icon -->
                  <div class="flex-grow-1 ml-3 flex align-content-center flex-column">
                    <div class="text-sm text-color-secondary mb-1 flex justify-content-between">
                      <div>{{ agendaMenuItem.labelPrefix }}</div>
                      @if (agendaMenuItem.room) {
                        <div>Room: {{ agendaMenuItem.room }}</div>
                      }
                    </div>

                    <h3 class="m-0 text-lg md:text-xl font-semibold">
                      {{ agendaMenuItem.label }}
                    </h3>
                  </div>

                  <!-- Chevron on the right -->
                  <i class="pi pi-angle-right text-2xl text-color-secondary ml-3"></i>
                </div>
              </div>
            </a>
          </div>
        }
      }
    </div>
  </div>

  @if (!isLoading && agendaMenuItemList.length === 0) {
    <div class="col-12 md:col-8 md:col-offset-2 lg:col-6 lg:col-offset-3 text-center">
      <div class="card-modern p-5">
        <i class="pi pi-info-circle text-4xl text-color-secondary mb-3"></i>
        <h3 class="text-xl font-semibold mb-2">No Agendas Found</h3>
        <p class="text-color-secondary">There are no active agendas for this event.</p>
      </div>
    </div>
  }

  @if (isLoading) {
    <div class="col-12 md:col-8 md:col-offset-2 lg:col-6 lg:col-offset-3 text-center">
      <div class="card-modern p-5">
        <i class="pi pi-spin pi-spinner text-4xl text-color-secondary mb-3"></i>
        <h3 class="text-xl font-semibold mb-2">Loading Agendas...</h3>
      </div>
    </div>
  }
</div>
